import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import shortid from "shortid";
import { Link, withRouter } from "react-router-dom";

const BreadCrumbPanelNew = props => {
  useEffect(() => {
    if (!!window) {
      window.addEventListener("scroll", fn_sticky_header);
    }
  }, []);

  const fn_sticky_header = () => {
    const sticky = document.querySelector(".for_scroll")
      ? document.querySelector(".for_scroll").offsetTop
      : false;
    const header = document.querySelector(".scrolledHeaderPopup");
    if (header && sticky) {
      if (window.pageYOffset >= sticky) {
        header.classList.add("fixed-header");
      } else {
        header.classList.remove("fixed-header");
      }
    }
  };

  return (
    <section className="breadcrumb_panel_section for_scroll">
      <div className="breadcrumbPanel">
        <ul>
          {props.breadcrumbs?.map((breadcrumb, index) => (
            <li
              key={shortid.generate()}
              className={props.breadcrumbs.length - 1 === index ? "last" : null}
            >
              {props.breadcrumbs.length - 1 === index ? (
                `${breadcrumb.label}`
              ) : (
                <Link to={breadcrumb.link}>{breadcrumb.label}</Link>
              )}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

const WithRouterBreadCrumbPanelNew = withRouter(BreadCrumbPanelNew);

const mapStateToProps = state => {
  return {
    vendorCommon: state.vendorCommon,
    vendorProfile: state.vendorProfile,
    websiteCommon: state.webSiteCommonData,
    vendorCaseStudies: state.vendorCaseStudies,
    vendorTestimonials: state.vendorTestimonials,
    vendorVideos: state.vendorVideos,
  };
};

export default connect(mapStateToProps)(WithRouterBreadCrumbPanelNew);
